package ai.jessie.web.pages.organisations

import ai.jessie.web.members.LocalMemberManagementPort
import ai.jessie.web.members.MemberManagementState
import ai.jessie.web.members.memberManagement
import ai.jessie.web.onboarding.onboardingProblem
import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import ai.jessie.web.theme.AlertStyle
import ai.jessie.web.theme.appFrame
import ai.jessie.web.theme.settingsSideGroups
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.dom.Div

// UC-005. Tenant state is keyed by the routed organisation, so a change of organisation discards
// it.
@Page("{organisationId}/members")
@Composable
fun organisationMembersPage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    if (!validOrganisationId(organisationId)) {
        appFrame(
            organisationId,
            membersHref(organisationId),
            MEMBERS_PAGE_TITLE,
            sideGroups = settingsSideGroups(organisationId, null),
        ) {
            Div(attrs = AlertStyle.toAttrs()) {
                onboardingProblem(organisationRequiredProblem(), busy = false)
            }
        }
    } else key(organisationId) { membersContent(organisationId) }
}

@Composable
private fun membersContent(organisationId: String) {
    val port = LocalMemberManagementPort.current
    val scope = rememberCoroutineScope()
    val model =
        remember(port, scope, organisationId) { MemberManagementState(port, scope, organisationId) }
    LaunchedEffect(model) { if (!AppGlobals.isExporting) model.refresh() }
    // The member listing carries no organisation name, so the side caption stays generic.
    appFrame(
        organisationId,
        membersHref(organisationId),
        MEMBERS_PAGE_TITLE,
        authenticationRequired = model.state.error?.authenticationRequired == true,
        sideGroups = settingsSideGroups(organisationId, null),
    ) {
        memberManagement(organisationId, model.state, model.actions)
    }
}

private fun membersHref(organisationId: String) = "/organisations/$organisationId/members"

// `20-EinstellungenTeam.png`: the page belongs to the settings area.
private const val MEMBERS_PAGE_TITLE = "Einstellungen"
